export default ":host ::ng-deep .mat-form-field {\n  width: 99% !important;\n}\n\n.etape_fin {\n  font-style: italic;\n  opacity: 0.8;\n}"